import { ContentRequest, useTaxGuideContent } from '@/api/tax-guide';
import React from 'react';
import RenderContent from '@/ui/templates/TaxGuideContent/RenderContent';
import DOMPurify from 'dompurify';
import { Box } from '@mui/material';
import LoadingShimmer from '../LoadingShimmer';

type Props = {
  country: string;
  plan: string;
  state: string;
  companyId: string;
};

// sample url to admin preview:https://gi-qa01.shareworks.com/preview?companyId=2234&countryId=ar&planId=1381&directLoginId=3159

const AdminPreview = (props: Props) => {
  const { country, plan, state, companyId } = props;

  const request = {
    companyId,
    countryId: country,
    planId: plan,
    stateId: state,
    serviceName: 'tax_guide',
    medium: 'html',
    language: 'en',
    templateType: 'adminPreview',
  } as ContentRequest;

  const { data: content, isPending, isFetching } = useTaxGuideContent(request);

  if (isPending && isFetching)
    return <LoadingShimmer call="partial" shimmerWidth={'95vw'} />;

  if (!content?.data.content) return <></>;

  const sanitizedBlog = DOMPurify.sanitize(content.data.content);

  return (
    <Box
      display={'flex'}
      justifyContent={'center'}
      id={'taxGuideContent'}
      style={{
        padding: 12,
        margin: 4,
      }}
    >
      <RenderContent
        htmlString={sanitizedBlog}
        chartContents={content.data.chartContents}
      />
    </Box>
  );
};

export default AdminPreview;
